import React from 'react';
import { TimerIcon } from 'lucide-react';
import { useLoopingCountdown } from '../hooks/useLoopingCountdown';
type CountdownTimerProps = {
  tone?: 'dark' | 'light';
};
export function CountdownTimer({
  tone = 'dark'
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useLoopingCountdown();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  const isDark = tone === 'dark';
  return <div className="flex w-full max-w-xl flex-col items-center" role="timer" aria-live="off" data-id="element-24" data-mp="1fc3pqxfkvygk">
      <p className={`mb-2 flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide ${isDark ? 'text-gold' : 'text-danger'}`} data-id="element-25" data-mp="1ach8mcwmpy2h">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-26" data-mp="15exv5f7r9pbl" />
        The $27 special price ends in
      </p>
      <div className="flex items-center gap-2" data-id="element-27" data-mp="34q8gp7zb89vt">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-28" data-mp="2zsqiocmtzf2l" data-mpi={i}>
            <div className={`flex w-[72px] flex-col items-center rounded-xl py-2 ${isDark ? 'bg-white/10 ring-1 ring-white/15' : 'bg-navy'}`} data-id="element-29" data-mp="2zpktyyi46f7e">
              <span className="font-display text-3xl font-black tabular-nums text-white" data-id="element-30" data-mp="1gxf3iyu6a79i">{u.value}</span>
              <span className="text-[10px] font-semibold uppercase tracking-wider text-white/70" data-id="element-31" data-mp="124vbouch3m7d">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className={`font-display text-2xl font-black ${isDark ? 'text-white/60' : 'text-navy/60'}`} data-id="element-32" data-mp="1uryalnl29yy5">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}